// ════════════════════════════════════════════════════════════════════════
//  Schlüssel sind über LEHRGÄNGE HINWEG eindeutig
//
//  `progress` hängt an (lesson_key, stage_key) und kennt keinen Lehrgang. Zwei
//  Lehrgänge mit demselben Stufenschlüssel teilen sich damit still den
//  Fortschritt der Kinder: wer in Grundkurs 2 übt, bekommt Sterne in
//  Grundkurs 1, und keine Anzeige führt darauf zurück.
//
//  Zufällige Schlüssel machen das unwahrscheinlich – aber nicht unmöglich, und
//  vor allem verhindern sie nicht den einen Weg, auf dem es sicher passiert: ein
//  kopiertes Bundle. `copyBundle` würfelt deshalb neu; diese Prüfung ist das
//  Netz darunter, denn eine Kopie kann auch von Hand entstehen.
//
//  Sie gehört NICHT nach packages/lehrgang: `checkBundle` prüft ein Bundle für
//  sich und kennt keine Datenbank. Was in anderen Lehrgängen steht, weiß nur die
//  Admin-App.
// ════════════════════════════════════════════════════════════════════════

import type { Bundle, Problem } from "@otto/lehrgang";

/**
 * @param bundle  Der Entwurf.
 * @param foreign Alle Schlüssel aller ANDEREN Lehrgänge. Der eigene gehört nicht
 *                dazu – sonst meldete jede zweite Fassung sich selbst.
 */
export function checkForeignKeys(
  bundle: Bundle,
  foreign: ReadonlySet<string>,
): Problem[] {
  const problems: Problem[] = [];

  for (const lesson of bundle.lessons) {
    if (foreign.has(lesson.key)) {
      problems.push({
        path: `lessons.${lesson.key}`,
        message:
          `Der Schlüssel dieser Lektion wird schon in einem anderen Lehrgang ` +
          `benutzt. Beide teilten sich damit den Fortschritt der Kinder.`,
      });
    }
    for (const stage of lesson.stages) {
      if (foreign.has(stage.key)) {
        problems.push({
          path: `lessons.${lesson.key}.${stage.key}`,
          message:
            `Der Schlüssel dieser Stufe wird schon in einem anderen Lehrgang ` +
            `benutzt. Beide teilten sich damit den Fortschritt der Kinder.`,
        });
      }
    }
  }

  // Der Test zählt mit: an seinem Schlüssel hängen die Messungen, und zwei
  // Lehrgänge mit demselben Schlüssel schrieben in dieselbe Zeile.
  if (bundle.assessment && foreign.has(bundle.assessment.key)) {
    problems.push({
      path: "assessment",
      message:
        `Der Schlüssel dieses Tests wird schon in einem anderen Lehrgang ` +
        `benutzt. Beide teilten sich damit die Messungen der Kinder.`,
    });
  }

  return problems;
}
